import { MultiViewBlock } from '@tribeplatform/react-components/Views'
import { useBlock } from '@tribeplatform/react-slate-kit/hooks'
import type { BC } from '@tribeplatform/react-slate-kit/types'

import { GenericPostsBlock } from './components/GenericPostsBlock.js'
import type { PostsBlockProps } from './types.js'

export const PostsBlock: BC<PostsBlockProps> = ({
  title,
  description,
  linkText,
  linkUrl,
  views,
  ...rest
}) => {
  const {
    extraContext: { activeViewIndex, activeFieldId },
  } = useBlock<
    PostsBlockProps,
    { activeViewIndex?: number; activeFieldId?: string }
  >()

  return (
    <MultiViewBlock
      activeViewIndex={activeViewIndex}
      title={title}
      description={description}
      views={views}
      linkUrl={linkUrl}
      linkText={linkText}
      {...rest}
    >
      {({ view, preview }) => (
        <GenericPostsBlock
          view={view}
          preview={preview}
          activeFieldId={activeFieldId}
        />
      )}
    </MultiViewBlock>
  )
}
